export const type = 'form.phone';
